export const TAB_NEWS = 'NEWS';
export const TAB_INDIVIDUAL_NOTICE = 'INDIVIDUAL_NOTICE';

export const LABEL_NEWS = 'イベント';
export const LABEL_INDIVIDUAL_NOTICE = 'あなたへのお知らせ';

export const TEXT_NO_MESSAGES = 'お客様へのお知らせはありません。';
